<template>
    <div class="associated-abacuses">
        <transition-group tag="div" class="item-list" name="fade">
            <a
                v-for="(abacus, index) in abacuses"
                :key="abacus.code"
                v-if="isDisplayable(index)"
                class="item"
                :href="abacus.value.large"
                data-mediabox="associated-abacus-gallery"
                @click="enableBlur()"
            >
                <div class="top-part" :style="`background-image: url(${abacus.value.large});`">
                    <div class="overlay">
                        <span class="icon-container">
                            <span class="icon-zoom" aria-label="icon zoom"></span>
                        </span>
                    </div>
                </div>
                <div class="bottom-part">
                    <h4 class="abacus-title">
                        {{ abacus.label }}
                    </h4>
                </div>
            </a>
        </transition-group>
        <div class="show-more-container">
            <button
                class="button is-primary is-large is-rounded is-uppercase"
                :class="brandBackgroundColor"
                v-if="!showAll && showBtn"
                @click="triggerShowAll()"
            >
                <span>{{ $t("load_all_abacuses") }}</span>
                <span class="icon-plus is-tiny is-right-side"></span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AssociatedAbacuses',
        props: {
            abacuses: {
                type: Array,
                default: () => []
            },
        },
        data() {
            return {
                limit: 8,
                showAll: false,
            }
        },
        computed: {
            showBtn(){
                return this.abacuses.length > this.limit
            }
        },
        mounted(){
            this.bindLightbox();
        },
        methods: {
            isDisplayable(index){
                return (!this.showAll && index < this.limit) || this.showAll
            },
            bindLightbox(){
                this.$root.wamediabox.bindAll(document.querySelector(".associated-abacuses"));
            },
            triggerShowAll(){
                this.showAll = true;
                // On rebind les lightbox apres 100ms car ca ne fonctionne pas directement
                setTimeout(() => this.bindLightbox(), 100);
            },
        }
    }
</script>

<style lang="scss">
.associated-abacuses {
    .item-list {
        margin: 0 -10px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: left;

        @media #{$mq_phone} {
            margin: 0;
        }

        .item {
            position: relative;
            flex: 0 0 calc((100%/6) - 20px);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin: 10px;
            height: 250px;

            @media #{$mq_large_desktop} {
                flex: 0 0 calc((100%/5) - 20px);
            }

            @media #{$mq_small_desktop} {
                flex: 0 0 calc((100%/4) - 20px);
            }

            @media #{$mq_tablet} {
                flex: 0 0 calc((100%/3) - 20px);
            }

            @media #{$mq_phone} {
                flex: 0 0 100%;
                margin: 0 0 20px 0;
            }

            .top-part {
                position: relative;
                flex: 1 1 auto;
                height: 80%;
                width: 100%;
                border-radius: 20px;
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;

                &:hover {
                    &:after {
                        opacity: 1;
                    }

                    .overlay {
                        .icon-container {
                            transform: scale(1.1);
                        }
                    }
                }

                &:after {
                    content: '';
                    position: absolute;
                    top: -2px;
                    right: -2px;
                    bottom: -2px;
                    left: -2px;
                    display: block;
                    opacity: 0;
                    border-radius: 20px;
                    transition: opacity 0.3s ease;

                    @each $brand in $brands {
                        .brand-#{$brand} & {
                            &:hover {
                                border: solid 2px brand-color($brand);
                            }
                        }
                    }
                }

                .overlay {
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: rgba(0, 0, 0, 0.2);
                    border-radius: 20px;

                    .icon-container {
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 43px;
                        height: 43px;
                        margin: 0 auto;
                        background-color: $white;
                        border-radius: 1000px;
                        transition: transform 0.3s ease;

                        [class^="icon-"], [class*=" icon-"] {
                            font-size: 15px;
                        }
                    }
                }
            }

            .bottom-part {
                position: relative;
                flex: 1 1 auto;
                height: 20%;
                display: flex;
                align-items: center;
                text-align: center;
                width: 100%;

                @media #{$mq_phone} {
                    justify-content: center;
                }

                .abacus-title {
                    font-size: 15px;
                    font-weight: 900;
                }
            }
        }
    }

    .show-more-container {
        margin-top: 30px;

        @media #{$mq_phone} {
            margin-top: 15px;
            text-align: center;
        }
    }
}
</style>
